import { gql } from '@apollo/client';

export const SING_IN = gql`
  query login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;
